import { IDevTools } from "@aurelia/state/src/interfaces-devtools";

import {
  CHANGE_LANGUAGE,
  DID_SHOW_WELCOME,
  FOLLOW_ALARMS,
  LOGIN,
  LOGOUT,
  SELECTED_VESSEL,
  SET_ALARM_KEYS,
  SET_DTN_AUTHORIZATION,
  TOGGLE_DARK_MODE,
  TOGGLE_IS_OPEN_FUEL_FILTERS,
  TOGGLE_SIDEBAR,
  TOGGLE_SIDEBAR_ORDER,
  TOGGLE_SOURCE_DATA_NAME,
  UPDATE_USER_SETTINGS,
} from "@/static/storeActions";

import { Alarms } from "./actions/alarms";
import { Auth } from "./actions/auth";
import { DtnWeather } from "./actions/dtn-weather";
import { Fuel } from "./actions/fuel";
import { Settings } from "./actions/settings";
import { Vessels } from "./actions/vessels";
import { IState } from "./state";

interface IStateAction {
  type: string;
  payload: any;
}

export function stateReducer(state: IState, action: IStateAction): IState {
  switch (action.type) {
    case LOGIN:
      return Auth.login(state, action.payload);
    case LOGOUT:
      return Auth.logout(state);
    case DID_SHOW_WELCOME:
      return Auth.didShowWelcome(state);
    case SET_ALARM_KEYS:
      return Alarms.setAlarmsKeys(state, action.payload);
    case FOLLOW_ALARMS:
      return Vessels.followAlarms(state, action.payload);
    case TOGGLE_DARK_MODE:
      return Settings.toggleDarkTheme(state);
    case TOGGLE_SOURCE_DATA_NAME:
      return Settings.toggleSourceDataName(state);
    case TOGGLE_SIDEBAR:
      return Settings.toggleSidebar(state);
    case TOGGLE_SIDEBAR_ORDER:
      return Settings.toggleSidebarOrder(state);
    case CHANGE_LANGUAGE:
      return Settings.changeLanguage(state, action.payload);
    case SELECTED_VESSEL:
      return Settings.selectedVessel(state, action.payload);
    case TOGGLE_IS_OPEN_FUEL_FILTERS:
      return Fuel.toggleIsOpenFuelFilters(state);
    case SET_DTN_AUTHORIZATION:
      return DtnWeather.setDtnAuthorization(state, action.payload);
    case UPDATE_USER_SETTINGS:
      return Settings.userSettings(state, action.payload);
    default:
      return state;
  }
}

export const updateDevtools = (state: IState, action: IStateAction) => {
  // @ts-expect-error - window.__REDUX_DEVTOOLS_EXTENSION__ is global

  const devtools = window.__REDUX_DEVTOOLS_EXTENSION__ as IDevTools;
  if (devtools) {
    devtools.send(action, state);
  }
  return state;
};
